module.exports = __webpack_public_path__ + "img/10.30eb27f2.png";